import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HorizontalMultlineTimelineComponent } from './horizontal-multiline-timeline/horizontal-multiline-timeline.component';
import { VerticalListTimelineComponent } from './vertical-list-timeline/vertical-list-timeline.component';
import { SharedModule } from '../../sub-modules/SharedModule';
import { ProjectSharedModule } from '../../sub-modules/project-modules/project-SharedModule';

@NgModule({
  declarations: [HorizontalMultlineTimelineComponent, VerticalListTimelineComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule, SharedModule, ProjectSharedModule],
  exports: [HorizontalMultlineTimelineComponent, VerticalListTimelineComponent],
})
export class TimelineSharedModule {}
